import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'authentication/services/authentication.service';
import { TokenService } from 'authentication/services/token.service';
import { switchMap } from 'rxjs';
import { Token } from 'shared/interfaces/token.interface';
import { StorageService, UserApiService } from 'shared/services';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';

@Component({
    selector: 'app-user-external-redirect',
    imports: [LoaderComponent],
    templateUrl: './user-external-redirect.component.html',
    styleUrl: './user-external-redirect.component.scss',
})
export class UserExternalRedirectComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private userApiService: UserApiService,
        private tokenService: TokenService,
        private storageService: StorageService,
        private destroyRef: DestroyRef,
    ) {}

    urlToken: string | null = null;
    urlListingId: string | null = null;
    urlPublicMediaId: string | null = null;
    urlTarget: string | null = null;

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.urlToken = params?.token ?? null;
            this.urlListingId = params?.listingId ?? null;
            this.urlPublicMediaId = params?.publicMediaId ?? null;
            this.urlTarget = params?.target ?? null;

            if (this.urlToken) {
                this.tokenService.setToken(undefined);
                this.storageService.clearSession();
                this.storageService.clearLocal();
                this.userApiService.removeCurrentUser();
                this.getCurrentUser(this.urlToken);
            }
        });
    }

    private getCurrentUser(urlToken: string): void {
        const token: Token = {
            token: urlToken,
            isShijiUser: false,
        };
        this.authenticationService.loginAndSetToken(token);
        // We call the getUserToken method with the redirectToLoginPageOnError parameter set to true
        // If we receive a 401 unauthorized error, we will redirect to the login page automatically and display
        // an error toast message
        this.authenticationService
            .getUserToken(token, undefined, true)
            .pipe(
                switchMap(() => this.userApiService.getCurrentUser()),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe({
                next: () => {
                    if (this.urlTarget === 'aiEdit') {
                        this.router.navigate(['ai-image-edit', this.urlListingId || '0', this.urlPublicMediaId || '0'], {
                            replaceUrl: true,
                        });
                    } else if (this.urlListingId) {
                        this.router.navigate(['listings', 'details', this.urlListingId, 'listingProfile']);
                    } else {
                        this.router.navigate(['']);
                    }
                },
            });
    }
}
